import * as React from 'react';

/** Keeps clicks/keys inside an inline editor from activating the clickable table row around it. */
export function StopRow({
  children,
  className = 'inline-block',
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={className}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}
